function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-len */
import { Avatar as ChakraAvatar } from '@chakra-ui/avatar';
import { chakra, forwardRef } from '@chakra-ui/system';
import React from 'react';

/**
 * Fallback avatar react component.
 */
var DefaultIcon = props => /*#__PURE__*/React.createElement(chakra.svg, _extends({
  viewBox: "0 0 178 178"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#F7F7F7",
  height: "178px",
  width: "178px"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.8 156.1C172.8 156.1 87 118.7 -8.1 118.7C-23.7 194.7 -36.9 271 -46.5 345C7.4 348.2 61 353.8 114.5 360C144.3 231.8 172.8 156.1 172.8 156.1Z",
  fill: "#2D333A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.7004 125.7C109.748 125.7 126 109.448 126 89.4001C126 69.3522 109.748 53.1001 89.7004 53.1001C69.6525 53.1001 53.4004 69.3522 53.4004 89.4001C53.4004 109.448 69.6525 125.7 89.7004 125.7Z",
  fill: "#00B2E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.3 283.3C137.4 276.4 132.8 268.8 127.6 261.4C127.6 261.4 132.3 199.8 172.8 156.1C172.8 156.1 192.5 196.7 208.6 252.9C174.4 263.8 147.6 279.5 141.3 283.3Z",
  fill: "#2D333A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.7 53.1C80.8 53.1 72.8 56.3 66.5 61.6C49.4 48.7 40.9 38.5 40.8 38.3C38.6 35.6 34.6 35.1 31.8 37.4C29.1 39.6 28.6 43.6 30.9 46.4C31.4 47 42.2 60.1 64.4 75.8C64.9 76.1 65.4 76.5 65.9 76.8C68.1 78.3 70.3 79.8 72.7 81.4C94.2 95.4 117 102.4 123 104.1C125 99.6 126.2 94.6 126.2 89.3C126 69.4 109.8 53.1 89.7 53.1Z",
  fill: "#2D333A"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  height: "178px",
  width: "178px"
}))));

export var Avatar = forwardRef((props, ref) => {
  var {
    icon = /*#__PURE__*/React.createElement(DefaultIcon, {
      borderRadius: "full"
    })
  } = props;
  return /*#__PURE__*/React.createElement(ChakraAvatar, _extends({
    icon: icon,
    ref: ref
  }, props));
});
//# sourceMappingURL=avatar.js.map